var createReactClass = require('create-react-class');
import React from 'react';

const CreateListModal = createReactClass({
  getDefaultProps: function() {
    var param = $("[name='csrf-param']").attr("content");
    var token = $("[name='csrf-token']").attr("content");

    return {
      csrfParam: param,
      csrfToken: token
    };
  },

  render: function() {
    return (
      <div className="cureus-custom-multi-select-modal reveal-modal middling" data-reveal>
        <div className="modal-body">
          <div className="modal-close">
            <a className="cancel-modal">
              <img alt="Close_x" src="https://public.cureus.com/close_x.png"/>
            </a>
          </div>

          <div className="modal-content">
            <div className='modal-form'>
              <h5>
                Create New List
              </h5>

              <form ref='form' acceptCharset='UTF-8' className='custom' method='post' action={this.props.createListUrl}>
                <input name="utf8" type="hidden" value="✓" />
                <input type="hidden" name={ this.props.csrfParam } value={ this.props.csrfToken } />
                <input type="hidden" name="list_type" value={ this.props.listType } />

                <label htmlFor='create-list-title'> Title </label>
                <input id='create-list-title' type='text' name='email_list[title]' required='required'/>

                <div className='modal-footer'>
                  <a className='cancel-modal button secondary'>CANCEL</a>
                  <input type='submit' value="CREATE LIST" className='button primary'/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
});

export default CreateListModal;